import React from "react";
import { FaLightbulb, FaHandshake, FaBullseye, FaTrophy } from "react-icons/fa";
import "./MissionValues.css";

const values = [
  { title: "Innovation", icon: <FaLightbulb /> },
  { title: "Integrity", icon: <FaHandshake /> },
  { title: "Customer-Centric Approach", icon: <FaBullseye /> },
  { title: "Excellence", icon: <FaTrophy /> }
];

const MissionValues = () => {
  return (
      <section className="mission-section">
        <div className="section-content">
          <h2>Our Mission & Values</h2>
          <p>
            Our mission is to provide the best solutions for our clients by
            maintaining high standards of professionalism and integrity.
          </p>
          <div className="values-grid">
            {values.map((value, index) => (
              <div key={index} className="value-card">
                <div className="value-icon">{value.icon}</div>
                <h3>{value.title}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>

  );
};

export default MissionValues;
